module.exports = __webpack_public_path__ + "static/media/galeryBaseboards1.cba488e1.jpg";